exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".subbar {\n  position: fixed;\n  top: 65px;\n  height: 65px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 64px;\n  z-index: 200;\n}", ""]);
